<template>
    <div id="contenedor-denegada-main">
      <v-card flat>
        <v-card-text>Acceso Restringido</v-card-text></v-card>
    </div>
</template>

<script>
export default {
  name: 'DenegadaMain',
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
